<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="status-card">
        <div class="status-card-title inf">VOLUME PERIOD IN PROGRESS</div>
        <div class="status-card-description">
          <p>The current volume period is in progress and will continue through the end date. 28 days after the end date,
            it will enter customer review period.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title warn">CUSTOMER REVIEW PERIOD</div>
        <div class="status-card-description">
          <p>The volume period has come to an end and requires your acceptance, dispute, or certification.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title err">DISPUTED</div>
        <div class="status-card-description">
          <p>The volume period was disputed and is being reviewed by a Contract Compliance Analyst.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="status-card">
        <div class="status-card-title inf">UNDER NS REVIEW</div>
        <div class="status-card-description">
          <p>NS is reviewing shipments which may qualify towards the volume commitment as a result of dispute.</p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="status-card">
        <div class="status-card-title support">CLOSED</div>
        <div class="status-card-description">
          <p>The volume period has ended. Volume has been met or liquidated damages have been accepted or disputed with resolution.</p>
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</div>
